import * as React from "react";
import PropTypes from "prop-types";
import { Box, Grid, Collapse } from "@material-ui/core";
import {
  SectionTitle,
  StyledGrid,
  StyledGridItem,
  Option,
} from "../../theme/Form";
import AddressForm from "./AddressForm";

const AddressSection = React.memo(function AddressSection({
  title,
  subtitle,
  defaultAddress,
  address,
  setAddress,
}) {
  const [open, setOpen] = React.useState(false);

  return (
    <Box component="section" pb={4}>
      <SectionTitle title={title} subtitle={subtitle} />

      <StyledGrid container direction="column">
        <StyledGridItem position="bottom" item>
          <Option
            label={`Use default address ${
              defaultAddress ? `(${defaultAddress})` : ""
            }`}
            onClick={() => setOpen((s) => !s)}
            checked={!open}
          />
        </StyledGridItem>
        <Grid item container direction="column">
          <StyledGridItem position={open && "bottom"} item>
            <Option
              label="Use a different billing address"
              onClick={() => setOpen((s) => !s)}
              checked={open}
            />
          </StyledGridItem>

          <Collapse in={open}>
            <AddressForm address={address} setAddress={setAddress} />
          </Collapse>
        </Grid>
      </StyledGrid>
    </Box>
  );
});

AddressSection.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  defaultAddress: PropTypes.string.isRequired,
  address: PropTypes.object.isRequired,
  setAddress: PropTypes.func.isRequired,
};

export default AddressSection;
